// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"a81e4bc9","513":"6c449f84","703":"58e94636"}[chunkId] + ".chunk.js";
};